import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import UserStore from './store/UserStore';
import WebSocketStore from './store/WebSocketStore';
import MedicalStore from './store/MedicalStore';

export const MainContext = createContext(null);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // Вызывает повторные рендеры компонентов
    // <React.StrictMode>
    <MainContext.Provider
        value={{
            user: new UserStore(),
            ws: new WebSocketStore(),
            medicalStore: new MedicalStore(),
        }}
    >
        <App />
    </MainContext.Provider>
    // </React.StrictMode>
);

